<!-- <div class="content-cell">
    <div class="cell-head"><span class="header-text">Main Header</span></div>
    <div class="cell-content tabset-container" kvTabSetBackground>
        <nb-tabset fullWidth>
            <nb-tab tabTitle="Logo Navigation">
                <div class="stepper-container narrow">
                    <ngx-logo-navigation></ngx-logo-navigation>
                </div>
            </nb-tab>
            <nb-tab tabTitle="Main Navigation">
                <div class="stepper-container">
                    <ngx-main-navigation></ngx-main-navigation>
                </div>
            </nb-tab>
            <nb-tab tabTitle="Toolbar">
                <ngx-toolbar></ngx-toolbar>
            </nb-tab>
          </nb-tabset>
    </div>
</div> -->
<nb-tabset fullWidth>
    <nb-tab tabTitle="Brand">
        <div>
            <ngx-logo-navigation></ngx-logo-navigation>
        </div>
    </nb-tab>
    <nb-tab tabTitle="Theme">
        <div>
            <ngx-header-theme [headerType]="headerType"></ngx-header-theme>
            <!-- <ngx-main-navigation></ngx-main-navigation> -->
        </div>
    </nb-tab>
    <nb-tab tabTitle="User">
        <ngx-toolbar></ngx-toolbar>
    </nb-tab>
</nb-tabset>
<!-- <nb-accordion multi kwExpandFirstItem>
    <nb-accordion-item>
        <nb-accordion-item-header>Logo Navigation</nb-accordion-item-header>
        <nb-accordion-item-body>
            <ngx-logo-navigation></ngx-logo-navigation>
        </nb-accordion-item-body>
    </nb-accordion-item>
    <nb-accordion-item>
        <nb-accordion-item-header>Main Navigation</nb-accordion-item-header>
        <nb-accordion-item-body>
            <ngx-main-navigation></ngx-main-navigation>
        </nb-accordion-item-body>
    </nb-accordion-item>
    <nb-accordion-item>
        <nb-accordion-item-header>Tool Bar</nb-accordion-item-header>
        <nb-accordion-item-body>
            <ngx-toolbar></ngx-toolbar>
        </nb-accordion-item-body>
    </nb-accordion-item>
</nb-accordion> -->
